// Do nothing
export default (props) => (props);



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/changeQuestionType/toTable/fromTextArea.js